import { Injectable } from '@angular/core';
import { DealerLocation, ResidenceInfo } from 'graphql-client';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrequalService {
  private _incomeData: any;
  private _secondaryIncomeData: any;
  public errorTriggered = new Subject<any>();
  ssnInvalidErrorMessage = new BehaviorSubject(false);
  ssnInvalidErrorMessage$ = this.ssnInvalidErrorMessage.asObservable();

  private _personalData = new BehaviorSubject<any>(null);
  _personalData$ = this._personalData.asObservable();

  //for progress bar

  INITAL_PREV_STEP = 0;
  private prev_step = new BehaviorSubject(this.INITAL_PREV_STEP);
  previous_step$ = this.prev_step.asObservable();
  _identityData: any;
  _residenceData: ResidenceInfo = undefined!;
  _dealerLocations: DealerLocation[] = [];
  _isGoogleAutoCompleteWorking: boolean = false;

  setPersonalData(data: any) {
    this._personalData.next(data);
  }

  //for progress bar
  updatePrevStep(step: number) {
    this.prev_step.next(step);
  }
  private primaryIncomeFieldAdded = new Subject();
  primaryIncomeFieldAdded$ = this.primaryIncomeFieldAdded.asObservable();

  private secondaryIncomeAdded = new Subject();
  secondaryIncomeAdded$ = this.secondaryIncomeAdded.asObservable();

  updatePrimaryIncomeFieldAdded(value: boolean) {
    this.primaryIncomeFieldAdded.next(value);
  }

  setIncomeData(data: any) {
    this._incomeData = data;
  }

  getIncomeData() {
    return this._incomeData;
  }

  setResidenceData(data: ResidenceInfo) {
    this._residenceData = data;
  }

  getResidenceData() {
    return this._residenceData;
  }
  setSecondaryIncomeData(data: any) {
    this._secondaryIncomeData = data;
  }
  getSecondaryIncomeData() {
    return this._secondaryIncomeData;
  }

  updateSecondaryIncomeAdded(value: boolean) {
    this.secondaryIncomeAdded.next(value);
  }

  triggerErrorScreen(message: any) {
    this.errorTriggered.next(message);
  }

  setIdentityData(data: any) {
    this._identityData = data;
  }

  getIdentityData() {
    return this._identityData;
  }
  setErrorMessage(errorMessage: boolean) {
    this.ssnInvalidErrorMessage.next(errorMessage);
  }

  getErrorMessage() {
    return this.ssnInvalidErrorMessage;
  }

  setDealerLocations(dealerLocations: DealerLocation[]) {
    this._dealerLocations = dealerLocations;
  }

  getDealerLocations() {
    return this._dealerLocations;
  }

  setIsGoogleAutoCompleteWorking(isGoogleAutoCompleteWorking: boolean): void {
    this._isGoogleAutoCompleteWorking = isGoogleAutoCompleteWorking;
  }

  getIsGoogleAutoCompleteWorking(): boolean {
    return this._isGoogleAutoCompleteWorking;
  }
}
